export const logoSmall = [
  '750 180',
  `
  <title>3DM logo</title>
  <style>.cls-1{fill:#575756;}.cls-2{fill:#e40521;}</style>
  <g>
    <g id="M"><path class="cls-1" d="M459.29,156.27h77.77l42.57,123.61c6.55,18.83,14.73,48.29,14.73,48.29h.82s8.19-29.46,14.73-48.29l42.57-123.61h77.77L754,448.92H682.36l-9-131.8c-1.64-22.1,0-49.11,0-49.11h-.82s-9.82,30.7-16.37,49.11l-30.7,84.73h-61.4l-30.69-84.73C526.83,298.71,517,268,517,268h-.82s1.64,27,0,49.11l-9,131.8h-72Z" transform="translate(-20.87 -156.27)"/></g>
    <g id="_3" data-name="3"><path class="cls-2" d="M55.25,360.1s26.2,26.2,60.17,26.2c26.6,0,41.75-13.1,41.75-29.06,0-22.93-22.93-32.34-54.44-32.34H82.26L67.12,290.11l38.48-46.25A317.72,317.72,0,0,1,131,216.44v-.82s-9.41,2-27.83,2h-70V156.27H217.74v44.61l-59.35,68.36C201.78,278.65,229.2,313,229.2,354c0,49.94-35.2,99.87-108.46,99.87-65.49,0-99.87-38.47-99.87-38.47Z" transform="translate(-20.87 -156.27)"/></g>
    <g id="D"><path class="cls-1" d="M211.43,156.27h104c92.09,0,151,53.62,151,145.71s-58.94,146.94-151,146.94h-104Zm101.1,231.25c49.52,0,79.81-29.46,79.81-85.54,0-55.66-31.51-84.32-79.81-84.32H283.06V387.52Z" transform="translate(-20.87 -156.27)"/></g>
 
  </g>
`,
]
